document.addEventListener('DOMContentLoaded', () => {
  const button = document.getElementsByClassName('cookie__button')[0];
  if (typeof button !== 'undefined') {
    button.onclick = function () {
      document.cookie = 'cookieConsent=true; max-age=31536000';
      document.getElementsByClassName('cookie')[0].classList.add('cookie--hidden');
    };
  }
});
